import React, { useEffect, useRef, useState } from 'react';

import { animateNumber, dotFormatter } from '../../../../../helpers';

interface SidebarJackpotTierProps {
  amount: number;
  className?: string;
}

export const SidebarJackpotTier: React.FC<SidebarJackpotTierProps> = ({
  amount,
  className
}) => {

  const displayAmountRef = useRef<HTMLDivElement | null>(null);

  const [displayAmount, setDisplayAmount] = useState(amount);

  useEffect(() => {
    setDisplayAmount(amount);
    animateNumber(displayAmountRef.current, displayAmount, amount, 500);
  }, [amount]);

  return (
    <div className="new-jackpot-block-content-items">
      <p className="new-jackpot-amount-text" ref={displayAmountRef}>
        {dotFormatter(displayAmount, 2)}
      </p>
      <div className={`new-jackpot-symbol ${className}`} />
    </div>
  );
};
